import { useMemo } from 'react';
import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { usePlatformOrganizationId } from '@/clients/platformInfo/usePlatformInfo.ts';
import { toLineItemProductConfigurations } from '@/shared/forms/FinanceSettingsForm/utils/toLineItemProductConfigurations.ts';
import { generateLineItemsByProductConfigurations } from '@schuettflix/summary';
import {
    groupLineItemsByOrganization,
    FinanceSettingsOrganization,
} from '@/shared/forms/FinanceSettingsForm/domain/groupLineItemsByOrganization.ts';

export function useFinanceSettingsOrganizations(
    productConfigurations: ProductConfiguration[],
    customerOrganizationId: number
): FinanceSettingsOrganization[] {
    const platformOrganizationId = usePlatformOrganizationId();

    return useMemo(() => {
        const lineItems = generateLineItemsByProductConfigurations({
            customerOrganizationId,
            platformOrganizationId,
            productConfigurations: toLineItemProductConfigurations(productConfigurations),
        });
        return groupLineItemsByOrganization({ lineItems, platformOrganizationId, customerOrganizationId });
    }, [productConfigurations, customerOrganizationId, platformOrganizationId]);
}
